import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import DetailsView from "../core/detailsView";
import { api } from "../../api";

import { getDetailViewConfig } from "./configs/incidentsDetailViewConfig";

const IncidentPage = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [detailViewConfig, setDetailViewConfig] = useState({});
  const [data, setData] = useState(state);

  // Load the incident. Normally we arrive with router state (from the list). When navigated by
  // id without state — e.g. from a notification or a direct link — fetch the record by id.
  useEffect(() => {
    const fetchData = async () => {
      let record = state;
      if (!record && id) {
        const res = await api("get", { id }, "Incidents");
        if (res.status === 200) {
          record = res.data && res.data.data ? res.data.data : res.data;
        }
      }
      if (record) setData({ ...record });
      const config = await getDetailViewConfig(record);
      setDetailViewConfig(config);
    };
    fetchData();
    // eslint-disable-next-line
  }, [state, id]);

  return (
    <>
      {detailViewConfig?.type && data ? (
        <DetailsView
          data={data}
          titleConfig={detailViewConfig.titleConfig}
          type={detailViewConfig.type}
          title={detailViewConfig.title}
          tabs={detailViewConfig.tabs}
          mainAction={detailViewConfig.mainAction}
          actionItems={detailViewConfig.actionItems}
          headerConfig={detailViewConfig.headerConfig}
        />
      ) : (
        <div></div>
      )}
    </>
  );
};

export default IncidentPage;
